import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ded779d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-text-center ion-margin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_back_button, {
                "default-href": "/tabs/permissions",
                slot: "start"
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("Create security group")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("main", null, [
            _createVNode(_component_ion_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_input, {
                      label: _ctx.translate('Name'),
                      "label-placement": "floating",
                      onIonBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData.groupId ? null : _ctx.setGroupId(_ctx.formData.groupName))),
                      modelValue: _ctx.formData.groupName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.groupName) = $event))
                    }, null, 8, ["label", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, {
                  ref: "groupId",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_input, {
                      label: _ctx.translate('Internal ID'),
                      "label-placement": "floating",
                      onIonChange: _ctx.validateGroupId,
                      onIonBlur: _ctx.markGroupIdTouched,
                      modelValue: _ctx.formData.groupId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.groupId) = $event)),
                      errorText: _ctx.translate('Internal ID cannot be more than 20 characters.')
                    }, null, 8, ["label", "onIonChange", "onIonBlur", "modelValue", "errorText"])
                  ]),
                  _: 1
                }, 512),
                _createVNode(_component_ion_item, { lines: "none" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_textarea, {
                      label: _ctx.translate('Description'),
                      "label-placement": "floating",
                      modelValue: _ctx.formData.description,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.description) = $event)),
                      counter: true,
                      maxlength: 255
                    }, null, 8, ["label", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_ion_button, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createGroup()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "start",
                    icon: _ctx.addOutline
                  }, null, 8, ["icon"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.translate("Create security group")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}